export const ContentTagCode = {
    // base
    Czech: "cs",
    English: "en",

    // landing pages
    CustomerZoneCs: "customer-zone-cs",
    CustomerZoneEn: "customer-zone-en",
    DevelopmentCs: "development-cs",
    DevelopmentEn: "development-en",
    ProductAndMarketingCs: "product-and-mktg-cs",
    ProductAndMarketingEn: "product-and-mktg-en",
    TechnicalSeoCs: "technical-seo-cs",
    TechnicalSeoEn: "technical-seo-en",
    UXAuditCs: "ux-audit-cs",
    UXAuditEn: "ux-audit-en",
    UXDesignCs: "ux-design-cs",
    UXDesignEn: "ux-design-en",
    WebAppsCs: "web-apps-cs",
    WebAppsEn: "web-apps-en",
};
